import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@p81-common/ui';

const createClasses = makeStyles<Theme>(theme => ({
  // Incompressible and non-growing, so the group never truncates and the
  // three-column bar can measure it. `gap` replaces the per-button marginLeft,
  // which used to apply to the first button too and offset the whole group.
  root: {
    display: 'flex',
    flex: '0 0 auto',
    alignItems: 'center',
    gap: theme.spacing(1),
    whiteSpace: 'nowrap'
  },
  button: {
    borderRadius: theme.spacing(2),
    height: theme.spacing(4),
    padding: theme.spacing(1, 1.5),
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary[500],
    // The strip these sat on used to be light grey, so a white button read as
    // a button. In the top bar it is white on white, hence the outline.
    border: `1px solid ${theme.palette.primary[200]}`,
    '&:hover': {
      backgroundColor: theme.palette.secondary[100],
      color: theme.palette.primary[500]
    },
    // Direct child only. The p81 Button wraps children in a Typography
    // `component="span"`, which is what this is meant to flex. Unscoped it also
    // matched the nested `code` span below and beat its `display: none`.
    '& > span:first-of-type': {
      display: 'flex',
      alignItems: 'center'
    },
    // Flag-only below customsm: breadcrumb yields first, region second.
    [theme.breakpoints.down('customsm')]: {
      padding: theme.spacing(1),
      minWidth: 'unset'
    }
  },
  activeButton: {
    backgroundColor: theme.palette.secondary[700],
    color: theme.palette.common.white,
    // Same border width as the unselected buttons, in its own fill, so
    // selecting a region does not resize it or shift the group.
    borderColor: theme.palette.secondary[700],
    '&:hover': {
      backgroundColor: theme.palette.secondary[700],
      color: theme.palette.common.white
    }
  },
  loadingButton: {
    opacity: 0.7,
    cursor: 'not-allowed',
    pointerEvents: 'none'
  },
  icon: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    marginRight: theme.spacing(0.5),
    [theme.breakpoints.down('customsm')]: {
      marginRight: 0
    }
  },
  code: {
    [theme.breakpoints.down('customsm')]: {
      display: 'none'
    }
  }
}));

export default createClasses;
